/**
 *
 * User: mphee
 * Date: 1/29/13
 * Time: 1:14 PM
 *
 */
define(function (require) {
    "use strict";
    var $ = require('jquery'),
        _ = require('underscore'),
        Backbone = require('backbone'),
        Const = require('common/Const'),
        html_template = require('common/templates/notifications/StudyBundleNotification.html'),
        template = _.template(html_template);
    
    return Backbone.View.extend({
        dispatcher: null,

        events: {
            'click a.sb-close': 'onCloseNotification',
            'click .buttonContainer a': 'onCloseLevelZeroNotification'
        },

        initialize: function () {
            this.notification = this.options.notification;

            Backbone.on('studybundle:rendered', _.bind(this.render, this));
        },

        /**
         * todo: notifications need object around them to deal with parsing and such.
         *
         * @return {*}
         */
        render: function () {
            var me = this;
            
            var data = this._prepareData();
            
            this.$el.html(template(data));
            $('#study-plan').find(".immersion").first().parent().append(this.$el);
            return this;
        },

        onCloseNotification: function() {
            Backbone.trigger("notifications:onConfirm", this.notification);
            var me = this;
            this.$el.fadeTo('slow', 0.25, function () {
                me.remove();
            });

        },
        
        onCloseLevelZeroNotification: function(event) {
        	event.preventDefault();
        	Backbone.on("notifications:onConfirmed", _.bind(this.redirectLevelZero, this));
            Backbone.trigger("notifications:onConfirm", this.notification);
        },

        show: function() {
        },
        
        redirectLevelZero : function(){
        	window.location.href = this.notification.url;
        },
        
        _prepareData: function() {
            var data = {
                title: this.notification.title,
                notification: this.notification.notification,
                type : this.notification.type,
                username : oeApp.getData('person').displayName,
                i18n: i18n,
                Const :  Const, 
                i18nPage: i18n.notifications.liveClassStarting
            };
            
            return data;
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./js/common/views/notifications/StudyBundleNotification.js
// module id = 1072
// module chunks = 26 27 28